import React from 'react'
import { get } from 'lodash'
import config from 'config'
import { Activity as AssessorActivityPage } from 'containers/pages/register'
import * as Assessor from 'containers/forms/assessor'
import { Redirect } from 'react-router-dom'

const urlPrefix = `${config.publicPath}/register/activity`

export default [
  {
    path: `${urlPrefix}`,
    component: props => (
      <AssessorActivityPage logout {...props} />
    ),
    routes: [
      {
        path: `${urlPrefix}`,
        exact: true,
        component: props => (
          <Redirect to={{
            pathname: `${config.publicPath}/register/activity/welcome`,
            search: get(props, 'location.search')
          }}
          />
        ),
        routes: []
      },
      {
        path: `${urlPrefix}/welcome`,
        exact: true,
        component: props => (
          <Assessor.Qualification {...props} />
        ),
        activeId: 1,
        routes: []
      },
      {
        path: `${urlPrefix}/success`,
        exact: true,
        component: props => (
          <Assessor.Success {...props} />
        ),
        activeId: 2,
        hideLocaleSwitcher: true,
        routes: []
      }
    ]
  }
]
